<template>
  <div class="main about">
    <h1 class="page-title">About</h1>
    <AboutTopPanel />
    <div class="about-container">
      <Skills />
      <div class="divider"><p>. . .</p></div>
      <Education />
      <div class="divider"><p>. . .</p></div>
      <Community />
      <div class="divider"><p>. . .</p></div>
      <Awards />
    </div>
  </div>
</template>

<script>
import AboutTopPanel from "./AboutTopPanel.vue";
import Skills from "./Skills.vue";
import Education from "./Education.vue";
import Awards from "./Awards.vue";
import Community from "./Community.vue";

export default {
  name: "About",
  components: {
    AboutTopPanel,
    Skills,
    Education,
    Awards,
    Community
  },
  data() {
    return {
      showCourses: false,
      courseBtn: "Show More"
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";
@import "./style.scss";

.about {
  p {
    font-size: $font-S;
  }

  .about-container {
    color: $text-grey;
    max-width: 1200px;
    margin: 0 auto;
  }

  .divider {
    color: $accent-pink;
    display: flex;
    justify-content: center;
    font-size: $font-L;
    font-weight: bold;
    margin: 5px 0;

    p {
      margin: 0;
    }
  }
}

@media only screen and (min-width: $phone-S) {
  .about {
    .about-container {
      .courses {
        .grid-container {
          flex-direction: column;
        }
      }
    }
  }
}

@media only screen and (min-width: $tablet-potrait) {
  .about {
    .about-container {
      h2 {
        margin-top: 40px;
      }

      .courses {
        .grid-container {
          flex-direction: row;
        }
      }
    }
  }
}

@media only screen and (min-width: $desktop-lg) {
  .about {
    .about-container {
      padding: 0 50px;
    }
  }
}

@media only screen and (min-width: $desktop-xlg) {
  .about {
    .about-container {
      padding: 0 150px;
    }
  }
}
</style>
